import { useTranslation } from 'react-i18next';

const MAIN_URL = 'https://kaspreadsheet.com';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=Luxury%20fashion%20flat%20lay%20with%20designer%20sneakers%20hoodies%20and%20accessories%20artfully%20arranged%20on%20a%20warm%20terracotta%20and%20cream%20marble%20surface%20premium%20editorial%20product%20photography%20rich%20textures%20vibrant%20streetwear%20items%20bold%20styling%20European%20fashion%20aesthetic%20high%20contrast%20soft%20golden%20sunlight&width=1600&height=900&seq=achb-hero-premium-v3&orientation=landscape&nocache=true';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src={HERO_IMAGE}
        alt="AllChinaBuy Spreadsheet — premium product finds directory"
        title="AllChinaBuy Spreadsheet — Find Products, Check QC & Shop Smarter"
        className="absolute inset-0 w-full h-full object-cover object-center"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-8">
          <i className="ri-sparkling-line text-white/90 text-sm"></i>
          <span className="text-white/90 text-xs font-medium tracking-wider uppercase">
            Updated Weekly · 2026 Edition
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          {t('home.hero.title').split('—')[0]}
          <br />
          <span className="text-primary-300">
            {t('home.hero.title').includes('—')
              ? t('home.hero.title').split('—').slice(1).join('—')
              : 'Find Products, Check QC & Shop Smarter'}
          </span>
        </h1>

        <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          {t('home.hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={MAIN_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('cta.spreadsheet')}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={MAIN_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('cta.buyNow')}
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>

        <div className="mt-16 flex items-center justify-center gap-8 text-white/50 text-sm flex-wrap">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>Updated Weekly</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>Quality Checked</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>14 Categories</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a
          href="#categories"
          className="text-white/50 hover:text-white/80 transition-colors duration-200 cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}